// extracted by mini-css-extract-plugin
export default {"container":"service-card_container__fnQMA"};